import { createAction, createSlice } from '@reduxjs/toolkit';
import { set as _set } from 'lodash';
import { resetReducer } from '../../reduxStore/actions/actions';

export interface ISurveyState {}

const initialState: ISurveyState = {};

export const surveySlice = createSlice({
	name: 'survey',
	initialState,
	reducers: {
		reset: () => ({}),
	},
	extraReducers: (builder) =>
		builder
			.addCase(boxAction, (state, action) =>
				_set(state, action.payload.id, action.payload.value),
			)
			.addCase(resetReducer, () => initialState)
			.addDefaultCase((state, action) => {}),
});

const boxAction = createAction<{ id: string; value: any }>(
	'@box/survey/update',
);
